window.POC = window.POC || {};

POC.state = {
  categories: [],
  selectedCategoryId: "ALL",
  selectedCategoryName: "All Curated Products",
  productsByCategory: {},
  productDetailCache: {},

  // 🔍 FILTER STATE (extended)
  filters: {
    search: "",
    curatedOnly: false,
    curatedFilter: "ALL",

    // NEW
    brand: "",
    color: "",
    size: ""
  },

  // 🆕 COMPARE STATE
  compare: {
    selected: [], // max 3 product IDs
    max: 3
  },

  modalPreview: {
    productId: "",
    selectedStyleId: "",
    selectedViewIndex: 0
  },

  categoryTree: {
    expanded: {}
  },

  isLoading: false,
  lastError: "",
  initialized: false
};